import { isAxiosError } from "axios";

export const templateErrorReasons = (error: unknown, status: number): Record<string, string> => {
    if (!isAxiosError(error) || error.response?.status !== status) {
        return {};
    }

    const reasons: unknown = error.response.data?.reasons;

    if (typeof reasons !== "object" || reasons === null) {
        return {};
    }

    return Object.fromEntries(Object.entries(reasons).filter(([, value]) => typeof value === "string"));
};

export const isStaleTemplateVersion = (error: unknown) => templateErrorReasons(error, 409).version === "stale_version";

export const templatePublicationFailure = (error: unknown) => {
    const reasons = templateErrorReasons(error, 422);

    return {
        sectorDetached: reasons.sectorId === "sector_not_attached",
        noAction: reasons.actions === "at_least_one_action_required",
        invalidForCatalogue: reasons.actions === "invalid_for_catalogue",
        unavailableSsqVersion: reasons.ssqVersionId === "ssq_version_unavailable",
    };
};
